/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MediaUserProfileResponseData
 */
export interface MediaUserProfileResponseData {
    /**
     * ユーザー名
     * @type {string}
     * @memberof MediaUserProfileResponseData
     */
    fullName: string;
    /**
     * 企業名
     * @type {string}
     * @memberof MediaUserProfileResponseData
     */
    companyName: string;
    /**
     * フォロー中（企業・ビジネスカテゴリ）の総数
     * @type {number}
     * @memberof MediaUserProfileResponseData
     */
    totalFollowingCount: number;
}

export function MediaUserProfileResponseDataFromJSON(json: any): MediaUserProfileResponseData {
    return MediaUserProfileResponseDataFromJSONTyped(json, false);
}

export function MediaUserProfileResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaUserProfileResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fullName': json['full_name'],
        'companyName': json['company_name'],
        'totalFollowingCount': json['total_following_count'],
    };
}

export function MediaUserProfileResponseDataToJSON(value?: MediaUserProfileResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'full_name': value.fullName,
        'company_name': value.companyName,
        'total_following_count': value.totalFollowingCount,
    };
}

